import { createSelector } from "reselect";
import get from "lodash/get";
import { genericSelector } from "ducks/selectors";

const cisFormHRDomain = state => get(state, "form.CisRequestHrForm.values", {});

/*
 ************** CIS Form Selectors ************
 */
export const cisHrSelector = createSelector(
  cisFormHRDomain,
  cisHrForm => cisHrForm
);

/*
 ************** Make Selectors ************
 */

export const makeSelectCisHrForm = () => cisHrSelector;

export const makeSelectCisFormHrInitialValues = () =>
  createSelector(genericSelector, generic => {
    return {
      country_code: get(generic, "contact_number.prefix")
    };
  });

export const makeSelectCisFormHrParams = () =>
  createSelector(cisHrSelector, cisHrForm => {
    return {
      external: {
        company_email: get(cisHrForm, "requestor_email"),
        contact_number: get(cisHrForm, "contact_number", ""),
        hr_email: get(cisHrForm, "email"),
        hr_name: get(cisHrForm, "full_name")
      }
    };
  });
